<template>
  <v-slide-x-reverse-transition>
    <v-sheet :style="style">
      <div v-if="!hideButton" style="display: flex; align-items: center">
        <v-btn icon large @click="handleClose"><v-icon>mdi-chevron-left</v-icon></v-btn>

        <slot name="menu"></slot>
      </div>
      <v-divider v-if="!hideButton" class="mb-0"></v-divider>
      <card
        style="overflow-y: auto"
        :style="`height: calc(100% - 44px ${fullscreen ? '' : ' - 64px'});`"
        margin="0"
        :title="title"
        :hideTitle="hideTitle || !title"
        :subtitle="subtitle"
        :loading="loading"
        :showGradient="showGradient"
        :outlined="false"
        :slotClass="slotClass"
      >
        <template #actions>
          <slot name="actions" />
        </template>
        <template #header>
          <slot name="header" />
        </template>
        <template #subtitle>
          <slot name="subtitle" />
        </template>
        <slot />
      </card>
    </v-sheet>
  </v-slide-x-reverse-transition>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Card from "./Card.vue";

@Component({
  components: { Card }
})
export default class SideCard extends Vue {
  @Prop({ default: false })
  fullscreen!: boolean;

  /**
   * Applies absolute position to side card
   */
  @Prop({ default: false })
  absolute!: boolean;

  @Prop({ default: false })
  showGradient?: boolean;

  @Prop({ default: "100%" })
  height!: string;

  @Prop({ default: "400px" })
  width!: string;

  @Prop()
  title!: string;

  @Prop({ default: false })
  hideTitle!: string;

  @Prop()
  subtitle?: string;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  hideButton!: boolean;

  /** Forwarded to Card's `slotClass` (applied to the scrollable content area, i.e. v-card-text). */
  @Prop({ default: "" })
  slotClass!: string;

  handleClose() {
    this.$emit("close");
  }

  get style() {
    const boxShadow = "-4px 0px 12px -2px rgba(0,0,0,0.2)";

    if (this.fullscreen) {
      return `position: fixed; top:0; right:0; bottom:0; width: ${
        this.$vuetify.breakpoint.smAndDown ? "100%" : this.width
      }; height: calc(${this.height}+64px); z-index:6; `;
    } else if (this.absolute) {
      return `
        position: fixed;
        top: 64px;
        right: 0;
        bottom: 0;
        box-shadow: ${boxShadow};
        width: ${this.$vuetify.breakpoint.smAndDown ? "100%" : this.width};
        height: ${this.height};
        z-index:6;
      `;
    } else {
      return `
        position: absolute;
        right:0;
        bottom:0;
        box-shadow: ${boxShadow};
        width: ${this.$vuetify.breakpoint.smAndDown ? "100%" : this.width};
        height: ${this.height};
        z-index:6;
      `;
    }
  }
}
</script>

<style></style>
